"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deepConvertMaps = deepConvertMaps;
function deepConvertMaps(value) {
    if (value instanceof Map) {
        return deepConvertMaps(Object.fromEntries(value));
    }
    if (value instanceof Set) {
        return Array.from(value).map(deepConvertMaps);
    }
    if (Array.isArray(value)) {
        return value.map(deepConvertMaps);
    }
    if (value !== null && typeof value === 'object') {
        return Object.fromEntries(Object.entries(value).map(([k, v]) => [k, deepConvertMaps(v)]));
    }
    return value;
}
//# sourceMappingURL=DeepConvertMaps.js.map